export const CTA_TYPES_FOR_TRACKING = {
  product: 'product',
  button: 'cta',
}

export const DATA_SELECTOR_ATTRIBUTE_FOR_SEO = 'buying-guide-content'
